import React from "react"
import {
  EmploymentIncome,
  SelfEmployment,
  SocialSecurity,
  Pension,
  Rental,
  Alimony,
  ChildSupport
} from "./IncomeDetailsView/worksheetTypes"

export const incomeTypes = {
  employment: {
    label: "Employment Income",
    cardType: "Employment",
    view: EmploymentIncome,
    description: (
      <span>
        Income reported on a W-2 is characterized as employment income. When
        earning income of this type, both you and your employer contribute to
        your Social Security and Medicare payments.
      </span>
    ),
    category: "employment"
  },
  selfemployment: {
    label: "Self Employment Income",
    cardType: "SelfEmployment",
    view: SelfEmployment,
    description: (
      <span>
        Income reported on 1099s is characterized as self-employment income.
        When earning income of this type, you will need to pay self-employment
        taxes for your future Social Security and Medicare benefits. You can put
        all of your self-employment income in one entry.
      </span>
    ),
    category: "employment"
  },
  socialsecurity: {
    label: "Social Security Income",
    cardType: "SocialSecurity",
    view: SocialSecurity,
    description: (
      <span>
        A Social Security benefit you are <strong>already receiving</strong>. If
        you are not already receiving Social Security, we'll automatically
        estimate it when planning your retirement or you can{" "}
        <a href="/organize/income+benefits/benefits/new/socialsecurity_plan">
          enter your estimated future benefit
        </a>
        .
      </span>
    ),
    category: "employment",
    validator: ({ people }) =>
      people
        .filter(({ role }) => role === "spouse" || role === "client")
        .filter(
          ({ birth_date }) =>
            new Date().getFullYear() - new Date(birth_date).getFullYear() >= 62
        ).length >= 1
  },
  pension: {
    label: "Pension Income",
    cardType: "Pension",
    view: Pension,
    description: <span>A pension benefit you are currently receiving.</span>,
    category: "employment",
    validator: ({ people }) =>
      people
        .filter(({ role }) => role === "spouse" || role === "client")
        .filter(
          ({ birth_date }) =>
            new Date().getFullYear() - new Date(birth_date).getFullYear() >= 55
        ).length >= 1
  }
}

// add types currently in development but not yet released to production
if (process.env.REACT_APP_DEPLOY_ENV !== "production") {
  incomeTypes["rental"] = {
    label: "Rental Income",
    cardType: "Rental",
    view: Rental,
    description: <span>A rental benefit you are currently receiving.</span>,
    category: "employment"
  }
  incomeTypes["alimony"] = {
    label: "Alimony Income",
    cardType: "Alimony",
    view: Alimony,
    description: (
      <span>
        Financial support that a person is ordered by a court to give during
        separation or following divorce.
      </span>
    ),
    category: "employment"
  }
  incomeTypes["childsupport"] = {
    label: "Child Support Income",
    cardType: "ChildSupport",
    view: ChildSupport,
    description: (
      <span>A child support benefit you are currently receiving.</span>
    ),
    category: "employment"
  }
}
